import { render, staticRenderFns } from "./CreateOrUpdateCompany.vue?vue&type=template&id=5538d2d6"
import script from "./CreateOrUpdateCompany.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports